import React from 'react'
import { Card, Heading, Paragraph, Button, defaultTheme, majorScale } from 'evergreen-ui'
import Logo from 'components/SideNav/WorkspaceLogo'

const Maintenance: React.FC = () => (
  <Card
    elevation={1}
    background="white"
    width={majorScale(60)}
    height={majorScale(40)}
    display="flex"
    alignItems="center"
    justifyContent="center"
    flexDirection="column"
    marginX="auto"
    style={{ borderTop: `5px solid ${defaultTheme.palette.green.base}` }}
  >
    <Logo />

    <Heading size={600} marginTop={majorScale(3)}>
      We will be back soon!
    </Heading>

    <Paragraph textAlign="center" maxWidth="50%" marginX="auto">
      We're rolling out a new user interface to manage your functions.
    </Paragraph>

    <Button is="a" href="mailto:friends@segment.com" marginTop={majorScale(2)}>
      Contact Support
    </Button>
  </Card>
)

export default Maintenance
